module.exports = __webpack_public_path__ + "static/media/omega_healthcare.44e89163.svg";